import axios from 'axios';

const isLocal = window.location.hostname === 'localhost';

export const HTTP = axios.create({
  baseURL: isLocal
    ? 'http://localhost:3000/api/'
    : 'https://vuejs-bosb-microsite.onrender.com/api/', // update with your Render URL
  headers: {
    Authorization: 'Bearer {token}',
    Accept: 'application/json'
  }
});
